<template>
    <div class="_activity sub_page">
        <section class="sub_page_con wrap_1120">
            <div class="sub_con_banner">
                <p>참여하고 싶은 반성매매 활동을 제안해주세요!</p>
            </div>
            <div class="btn_wrap _default right_btn _board_type">
                <button class="common_btn w_130" style="margin-bottom: 15px" @click="loginConfirm">글쓰기</button>
            </div>
            <div class="list_table con_board sub_page_con_view suggestList">
                <ul>
                    <li class="thead_li">
                        <div class="tr_div con_tit">
                            <div class="tb_no">번호</div>
                            <div class="tb_subject">제목</div>
                            <div class="tb_wr_name">조회수</div>
                            <div class="tb_wr_name">작성자</div>
                            <div class="tb_date_hour">작성일</div>
                        </div>
                    </li>
                    <li class="tbody_li" v-for="(item, idx) in state.list" :key="item.idx" v-if="state.list.length > 0">
                        <div class="tr_div con_tit">
                            <div class="tb_no no_768">{{ (state.page - 1) * state.size + (idx + 1) }}</div>
                            <div class="tb_subject">
                                <router-link :to="{ name: 'SuggestView', params: { id: item.idx } }" class="elips_1">
                                    {{ item.title }}
                                </router-link>
                            </div>
                            <template v-if="!state.isMobile">
                                <div class="tb_wr_name">
                                    <span class="mo_th">조회수</span>
                                    {{ CommonUtils.numberFormat(item.viewCnt) }}
                                </div>
                                <div class="tb_wr_name">
                                    <span class="mo_th">작성자</span>
                                    {{ item.writer }}
                                </div>
                                <div class="tb_date_hour">
                                    <span class="mo_th">날짜</span>
                                    {{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}
                                </div>
                            </template>
                            <template v-else>
                                <div class="_flex _flex_100 _jc_sb">
                                    <div class="_flex">
                                        <div class="tb_wr_name no_450">
                                            <span class="mo_th">조회수</span>
                                            {{ CommonUtils.numberFormat(item.viewCnt) }}
                                        </div>
                                        <span class="divider no_450">｜</span>
                                        <div class="tb_wr_name">
                                            <span class="mo_th">작성자</span>
                                            {{ item.writer }}
                                        </div>
                                    </div>
                                    <div class="tb_date_hour">
                                        <span class="mo_th">날짜</span>
                                        {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </li>
                    <li v-else class="tbody_li no_data">
                        <div class="tr_div">
                            <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                        </div>
                    </li>
                </ul>
            </div>

            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        userStore,
        useRoute,
        ModalDefault,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        setup() {
            const global = globalStore();
            const route = useRoute();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,

                list: [] as Array<any>,

                searchType: "" as string,
                searchText: "" as string,

                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isMobile: false,
            });

            onMounted(() => {
                getList();

                state.isMobile = window.innerWidth < 768;
            });

            const getList = async () => {
                const param: types.ReqBoardList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                };
                const res: types.ResReportList = await apiService.boardSuggest.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;

                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    router.replace({ path: "/login", query: { redirect: "/suggestWrite" } });
                }
            };

            const loginConfirm = () => {
                if (!(user && user.accessToken)) {
                    state.isShowModal = true;
                    state.modalTab = 7;
                    state.modalTitle = "안내";
                    state.modalContent = "로그인을 진행해주세요.";
                } else {
                    router.push("/suggestWrite");
                }
            };

            return { state, router, handlePageChange, getList, CommonUtils, loginConfirm, closeModal, callBackModal };
        },
    };
</script>
